export default {
  isAvailable: false,
  isLoading: false,
  isLoadingExport: false,
  isSubmitting: false,
  isSubmittingExport: false,
  errors: null,
  errorsExport: null,
};
